import {
    Box,
    Button,
    Flex,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Portal,
    Text,
    useToast
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { BsTrophyFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { IUserBadgeData } from "../../../models/admin/badges/userBadge.model";

export const ViewUserBadges: React.FC<any> = ({
    isOpenBadge,
    onClosed,
    isBadge = false,
    badges
}: {
    isBadge: boolean;
    isOpenBadge: any;
    onClosed: any;
    badges: IUserBadgeData[]
}) => {
    const toast = useToast();
    const cancelRef = useRef().current;
    const navigate = useNavigate()

    const [isView, setIsView] = useState(false)
    const [displayBadge, setDisplayBadge] = useState<IUserBadgeData>()

    const viewaBadge = (badge :IUserBadgeData) => {
        setDisplayBadge(badge)
        setIsView(true)
    }
    const closeBadge = () => {
        setIsView(false)
    }
    return (
        <>
            <Modal
                isOpen={isOpenBadge && isBadge}
                onClose={onClosed}
                scrollBehavior="outside"
                closeOnOverlayClick={true}
                size="lg"
            >
                <ModalOverlay />
                <ModalContent borderRadius={5} px={6}>
                    <ModalHeader>
                        {
                            <Text
                                fontSize={'18px'}
                                pb={3}
                                textTransform="capitalize"
                            >
                                User Badges
                            </Text>
                        }
                    </ModalHeader>
                    <ModalCloseButton size="sm" />
                    <ModalBody pb={'30px'}>
                        <Box mt={2}>

                            {
                                badges.length > 0 && badges.map((badge, index) => (
                                    <Flex key={index} pt={'10px'} px='10px' height='70px' alignItems={'center'} borderBottom={'2px solid lightgray'} justifyContent={'space-between'}>
                                        <HStack  >
                                            <Text><BsTrophyFill color="gold" fontSize={'24px'} /></Text>
                                            <Text textTransform={'capitalize'} cursor={'pointer'} >{badge.badge.name.toLowerCase()}</Text>
                                        </HStack>
                                        <Button size={'xs'} variant={'outline'} onClick={() =>{viewaBadge(badge)}} colorScheme="red">view</Button>
                                    </Flex>

                                ))
                            }
                        </Box>

                    </ModalBody>
                </ModalContent>
            </Modal>
            {
                isView && (
                    <Portal>
                        <Modal
                            isOpen={isView}
                            onClose={closeBadge}
                            scrollBehavior="outside"
                            closeOnOverlayClick={true}
                            size="lg"
                        >
                            <ModalOverlay />
                            <ModalContent >

                                <ModalCloseButton size="sm" />
                                <ModalBody color={'white'} bg={'blue'} >
                                    <Box px={'30px'} py={'15px'}>
                                        <Box mb={'40px'}>
                                            <Text color={'white'} textAlign={'center'} fontWeight={'500'} fontSize={'18px'}>CONGRATULATIONS</Text>
                                            <Text textAlign={'center'} fontWeight={'600'} fontSize={'18px'}>{displayBadge?.receiver.name}</Text>
                                        </Box>
                                        <Box mb='20px'>
                                            <Text textAlign={'center'} fontWeight={'600'} fontSize={'17px'}>You have recieved a</Text>
                                            <Text textAlign={'center'} fontWeight={'600'} textTransform={'uppercase'} fontSize={'25px'}>{displayBadge?.badge.name} BADGE</Text>
                                        </Box>
                                        <Flex justifyContent={'center'}>
                                            <BsTrophyFill color="gold" fontSize={'60px'} />
                                        </Flex>
                                    </Box>
                                    <Box mt={'20px'} py={'10px'}>
                                        <Text textAlign={'center'} fontWeight={'600'} fontSize={'15px'}>{displayBadge?.reason.name}</Text>
                                        <Text textAlign={'center'} fontWeight={'600'} fontSize={'15px'}>Naptin</Text>
                                    </Box>

                                </ModalBody>
                            </ModalContent>
                        </Modal>
                    </Portal>
                )
            }
        </>
    );
};
